import Vue from "vue";
import VueRouter from "vue-router";
import VueLocalForage from "vue-localforage";

const Login = () =>
  import("@/components/Login");
const Dashboard = () =>
  import("@/components/Dashboard");
const Saldo = () =>
  import("@/components/Saldo");
const Extrato = () =>
  import("@/components/Extrato");
const Lojas = () =>
  import("@/components/Lojas");
const Movimentacao = () =>
  import("@/components/Movimentacao");
const Logout = () =>
  import("@/components/Logout");
const ResetSenha = () =>
  import("@/components/ResetSenha");
const Recargas = () =>
  import("@/components/Recargas");
const Convenio = () =>
  import("@/components/Convenio");
const Mensagem = () =>
  import("@/components/Mensagem");

const Promocao = () =>
  import("@/components/Promocao");

  const Usuario = () =>
  import("@/components/Usuario");

  const Colaboradores = () =>
    import("@/components/Colaboradores");
Vue.use(VueRouter);
//Vue.use(VueLocalForage);

import EventBus from "../services/EventBus";
import {
  HTTP
} from "../services/http.axios";

const routes = [{
    path: "/lojas",
    name: "Lojas",
    component: Lojas
  },
  {
    path: "/movimentacao",
    name: "Movimentacao",
    component: Movimentacao
  },
  {
    path: "/mensagem",
    name: "Mensagem",
    component: Mensagem
  },
  {
    path: "/promocao",
    name: "Promocao",
    component: Promocao
  },
  {
    path: "/convenio",
    name: "Convenio",
    component: Convenio
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    component: Usuario
  },
  {
    path: "/colaboradores",
    name: "Colaboradores",
    component: Colaboradores
  },
  {
    path: "/recargas",
    name: "Recargas",
    component: Recargas
  },

  {
    path: "/",
    name: "Index"
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  }, ,
  {
    path: "/saldo",
    name: "Saldo",
    component: Saldo
  },
  {
    path: "/extrato",
    name: "Extrato",
    component: Extrato
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout
  },
 
  {
    path: "/resetSenha/:id_token",
    props: true,
    name: "ResetSenha",
    component: ResetSenha
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  suppressTransitionError: true
});

router.beforeEach(async (to, from, next) => {
  console.log(to);
  if (to.name == "ResetSenha") {
    await window.sessionStorage.setItem("menu", false);

    next();

    return false;
  }
  if (to.name == null) {
    next({
      name: "Login"
    });

    return false;
  }
  if (to.name !== "Login" && to.name !== "Index" && to.name !== "Logout") {
    window.sessionStorage.setItem("menu", true);
    EventBus.$emit("menuon");
    if (window.sessionStorage.getItem("token") !== "") {
      next();
    } else {
      EventBus.$emit("menuoff");
      window.sessionStorage.setItem("menu", false);
      next({
        name: "Login"
      });
    }
  } else {
    if (to.name === "Index") {
      next({
        name: "Login"
      });
    } else {
      EventBus.$emit("menuoff");
      window.sessionStorage.setItem("menu", false);
      next();
    }
  }
});

export default router;
/*if (window.sessionStorage.getItem("token")) {
      window.sessionStorage.setItem("menu", true);
      next();
      return;
    }
    window.sessionStorage.setItem("menu", false);
    next({ name: "Login" });
    return;
    //.logado = false;
  } else {
    window.sessionStorage.setItem("menu", false);
    next({ name: "Login" });
    return;
  }*/



// WEBPACK FOOTER //
// ./src/router/index.js